import { render } from "./DependenciaCSU.vue?vue&type=template&id=3d49aa3e&scoped=true"
import script from "./DependenciaCSU.vue?vue&type=script&lang=js"
export * from "./DependenciaCSU.vue?vue&type=script&lang=js"

import "./DependenciaCSU.vue?vue&type=style&index=0&id=3d49aa3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d49aa3e"]])

export default __exports__